export const scrollToElement = (id) => {
  const element = document.getElementsByName(id);
  if (element.length) {
    element[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
};
